// extracted by mini-css-extract-plugin
export var grid = "_24-0";
export var span1 = "_24-2";
export var span10 = "_24-b";
export var span10L = "_24-z";
export var span10M = "_24-n";
export var span10Xl = "_24-1b";
export var span11 = "_24-c";
export var span11L = "_24-10";
export var span11M = "_24-o";
export var span11Xl = "_24-1c";
export var span12 = "_24-d";
export var span12L = "_24-11";
export var span12M = "_24-p";
export var span12Xl = "_24-1d";
export var span1L = "_24-q";
export var span1M = "_24-e";
export var span1Xl = "_24-12";
export var span2 = "_24-3";
export var span2L = "_24-r";
export var span2M = "_24-f";
export var span2Xl = "_24-13";
export var span3 = "_24-4";
export var span3L = "_24-s";
export var span3M = "_24-g";
export var span3Xl = "_24-14";
export var span4 = "_24-5";
export var span4L = "_24-t";
export var span4M = "_24-h";
export var span4Xl = "_24-15";
export var span5 = "_24-6";
export var span5L = "_24-u";
export var span5M = "_24-i";
export var span5Xl = "_24-16";
export var span6 = "_24-7";
export var span6L = "_24-v";
export var span6M = "_24-j";
export var span6Xl = "_24-17";
export var span7 = "_24-8";
export var span7L = "_24-w";
export var span7M = "_24-k";
export var span7Xl = "_24-18";
export var span8 = "_24-9";
export var span8L = "_24-x";
export var span8M = "_24-l";
export var span8Xl = "_24-19";
export var span9 = "_24-a";
export var span9L = "_24-y";
export var span9M = "_24-m";
export var span9Xl = "_24-1a";
export var stretch = "_24-1";